import React from 'react';
import { IconProps } from '../icons/icons';

/**
 * SelectAll icon component
 *
 * @param props - SVG props
 */
export const SelectAll: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = '#000', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2 3.33333H3.33333V2C2.6 2 2 2.6 2 3.33333ZM2 8.66667H3.33333V7.33333H2V8.66667ZM4.66667 14H6V12.6667H4.66667V14ZM2 6H3.33333V4.66667H2V6ZM8.66667 2H7.33333V3.33333H8.66667V2ZM12.6667 2V3.33333H14C14 2.6 13.4 2 12.6667 2ZM3.33333 14V12.6667H2C2 13.4 2.6 14 3.33333 14ZM2 11.3333H3.33333V10H2V11.3333ZM6 2H4.66667V3.33333H6V2ZM7.33333 14H8.66667V12.6667H7.33333V14ZM12.6667 8.66667H14V7.33333H12.6667V8.66667ZM12.6667 14C13.4 14 14 13.4 14 12.6667H12.6667V14ZM12.6667 6H14V4.66667H12.6667V6ZM12.6667 11.3333H14V10H12.6667V11.3333ZM10 14H11.3333V12.6667H10V14ZM10 3.33333H11.3333V2H10V3.33333ZM4.66667 11.3333H11.3333V4.66667H4.66667V11.3333ZM6 6H10V10H6V6Z'
      fill={color}
    />
  </svg>
);

export default SelectAll;
